
<template>
  <div>
    <el-dialog
      :visible.sync="show"
      width="550px"
      :show-close="false"
      @close="close"
      center
    >
      <div class="detaiul_mians">
        <div class="detaiul_mians-tip">请使用微信支付</div>
        <p class="detaiul_mians-small">付款完成前请不要关闭弹窗</p>
        <div class="code_img">
          <div class="qrcode" ref="ercide"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    payCodeImg: [String],
  },
  watch: {
    show(val) {
      if (val) {
        console.log(val);
        setTimeout(() => {
          this.creatQrCode();
        }, 500);
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    creatQrCode() {
      new QRCode(this.$refs.ercide, {
        text: this.payCodeImg, // 要转换成二维码的内容
        width: 237,
        height: 233,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    close() {
      this.$refs.ercide.innerHTML = "";
      this.$emit("closeFun");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  display: none !important;
}
.detaiul_mians {
  width: 300px;
  text-align: center;
  margin: 0 auto;
}
.qrcode {
  margin: 20px auto;
  width: 237px;
  height: 233px;
}
</style>
